import React from 'react'
import cx from 'classnames'
import { useParticipants } from '@gopeerproject/web-kit'

import { User } from '@components/UI'
import { Classroom as ClassroomConstants } from '@constants'
import { useAuth } from '@hooks'

import { useClassroomQuery } from '../../hooks'

const ParticipantsCointainer = ({ step }) => {
  const { profile } = useAuth()

  const onlineParticipants = useParticipants().map((p) => p.identity)
  const { data } = useClassroomQuery()

  const participants = Object.keys(data?.participants || {}).reduce(
    (acc, key) => [...acc, { id: key, ...data?.participants[key] }],
    []
  )

  if (step !== ClassroomConstants.STEPS.READY) {
    return null
  }

  return (
    <div className='participants-container'>
      {participants
        .filter((p) => p.id !== profile.id)
        .map((p) => (
          <User
            key={p.id}
            className={cx('gp-user', {
              'gp-user--offline': !onlineParticipants.includes(p.id)
            })}
            img={p.image}
            name={p.name}
            type={p.type}
            hideName
            size='small'
          />
        ))}
    </div>
  )
}

export default ParticipantsCointainer
